import React from 'react'
import { useTranslation } from '@sailor/i18n-web'
import styles from './index.module.less'
import Container from '../Container'
import { picUrl } from '@/common/utils/consts'
import HighlightText from '../HighlightText'

const EmployeeDining = () => {
  const { t } = useTranslation()

  const diningCards = [
    {
      id: 'subsidy',
      image: picUrl.diningScene1,
      title: t('ent_o_dining_allowance', '餐饮津贴'),
      description: t('ent_o_dining_allowance_desc', '我们将在您设定的使用场景、使用范围和使用条件下，为您的员工提供丰富的点餐和就餐选择'),
    },
    {
      id: 'group',
      image: picUrl.diningScene2,
      title: t('ent_o_group_order', '团体订单'),
      description: t('ent_o_group_order_desc', '我们将整合区域餐饮及配送资源，为不同规模的企业提供高性价比、高定制化的团体订餐服务'),
    },
    {
      id: 'welfare',
      image: picUrl.diningScene3,
      title: t('ent_o_employee_benefits', '员工福利'),
      description: t('ent_o_employee_benefits_desc', '我们将为战略合作伙伴提供多样化的员工福利方案，包含提供企业餐饮特殊优惠、礼品卡券等多元化员工福利'),
    },
  ]

  return (
    <div>
      <Container gray  style={{ paddingBottom: 0 }}>
        <div className={styles.container}>
          {/* 标题区域 */}
          <div className={styles.titleWrapper}>
            <h2 className="section-title">
              <HighlightText>{t('ent_o_title_diverse_coverage1', '覆盖多样')}</HighlightText>
              <span>
                {t('ent_o_title_dining_scenario1', '员工用餐场景')}
              </span>
            </h2>
          </div>


        </div>
      </Container>
      <Container gray style={{ paddingTop: 0 }} contentClassName={styles.cardGridContainer}>
        {/* 卡片区域 */}
        <div className={styles.cardGridWrapper}>
          <div className={`${styles.cardGrid} ${styles.cardAnimation}`}>
            {diningCards.map(card => (
              <div
                key={card.id}
                className={styles.card}
              >
                <img src={card.image} alt={card.title}  className={styles.image}/>
                <div  className={styles.cardText}>
                  <h3 className={styles.cardTitle}>{card.title}</h3>
                  <p className={styles.cardDescription}>
                    {card.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>

    </div>
  )
}

export default EmployeeDining